import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { fetchPosts, fetchTopics } from "../lib/communityApi";
import { extractApiErrorMessage } from "../lib/format";

export function useFeed(token, topic) {
  const [topics, setTopics] = useState([]);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    fetchTopics()
      .then((t) => {
        if (mounted) setTopics(t);
      })
      .catch((err) => console.error("fetchTopics failed:", err));
    return () => {
      mounted = false;
    };
  }, []);

  const reload = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      const data = await fetchPosts(token, topic, 40);
      setPosts(Array.isArray(data?.items) ? data.items : []);
    } catch (err) {
      console.error("fetchPosts failed:", err);
      toast.error(extractApiErrorMessage(err, "Could not load the feed."));
    } finally {
      setLoading(false);
    }
  }, [token, topic]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { topics, posts, setPosts, loading, reload };
}
